import { HashrateItem } from "@components/Charts/ChartDatasetUtils";
import { CleanChartDataset, NullableChartPeriod } from "@components/Charts/CleanChart.control";
import { LiveValueListener, SocketContext } from "@components/Context/SocketContext";
import { SocketEventTypes } from "@services/http/socket/responses";
import { dev } from "@utils/dev";
import { Moment } from "moment-timezone";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SocketSubTypes } from "@services/http/socket/requests";
import { IStatisticControl3 } from "./types";
import mainLocationsStore from "@mobx/store/locations";
import { getMathValues3, IMathValues3 } from "@mobx/store/locations/types";
import { useAuth } from "@utils/hooks/useAuth";
import { GetAdminStatisticByLocation2, GetUserStatisticByLocation2 } from "@services/http/miners";
import useApiRequests from "@services/http/useApiRequest";
import BaseRequest from "@services/http/BaseRequest";
import { RecordResponse } from "wl-net";

interface ILocationStatistic3Props {
  //isOpen: boolean;
  //isAdmin: boolean;
}

export function useLocationStatisticControl3(locationID: number): IStatisticControl3 {

  const isLoadedRef = useRef(0);
  const auth = useAuth();
  // отказался пока от mainLocationsStore, т.к. вызывает ререндеры
  // const locationStoreRef = useRef(mainLocationsStore.locations[locationID]);
  const requests = useApiRequests();

  const {
    subscribe,
    unsubscribe,
    addMessageListener,
    removeMessageListener
  } = useContext(SocketContext);

  const [datasets, setDatasets] = useState<CleanChartDataset[]>([]);
  const [statistic, setStatistic] = useState<IMathValues3>([0, 0, 0, 0]); // min, max, avg, length
  const [isLoading, setLoading] = useState(false);

  // const isMountedRef = useRef(true);
  // useEffect(() => {
  //   isMountedRef.current = true;
  //   return () => { isMountedRef.current = false; };
  // }, []);

  const currentPeriodRef = useRef<[Moment | null, Moment | null]>([null, null]);

  const getStatisticByLocationOld = async (
    period: NullableChartPeriod,
    id: string,
    tag: string,
  ): Promise<HashrateItem[]> => {
    dev.logt("Location", `getStatisticByLocation ${tag}`, { id, period });
    setLoading(true);
    let result: HashrateItem[] = []
    let request: BaseRequest;
    if (auth.isAdmin) {
      request = new GetAdminStatisticByLocation2(period[0], period[1], id);
    } else {
      request = new GetUserStatisticByLocation2(period[0], period[1], id);
    }
    const response = await requests.enqueueSilent<RecordResponse<HashrateItem[]>>(request);
    if (response && response.Status === "success") {
      const values = getMathValues3(response.Record);
      setStatistic(values);
      result = response.Record;
    }
    setLoading(false);
    return Promise.resolve(result);
  };

  // const getStatisticByLocation = useCallback(async (
  //   period: NullableChartPeriod,
  //   tag: string,
  // ): Promise<HashrateItem[] | void> => {
  //   const locationStore = locationStoreRef.current;
  //   if (!isMountedRef.current) return;
  //   setLoading(true);
  //   const result = await locationStore?.getStatistics(period, auth.isAdmin);
  //   if (!isMountedRef.current) return;
  //   setLoading(false);
  //   if (result) {
  //     const values = getMathValues3(result);
  //     setStatistic(values);
  //   }
  //   return result;
  // }, []);

  const update = useCallback(async (period: NullableChartPeriod, tag: string) => {
    //const locationStore = locationStoreRef.current;
    const raw = await getStatisticByLocationOld(period, `${locationID}`, tag);
    if (raw === undefined) return;
    const dataset: CleanChartDataset = {
      label: `location-${locationID ?? ""}`,
      data: raw
    }
    setDatasets([dataset]);
  }, [getStatisticByLocationOld]);

  const load = async (listener: LiveValueListener) => {
    addMessageListener(SocketEventTypes.LOCATION_SPEED, listener);
    subscribe(SocketSubTypes.Location, locationID);
  };

  const unload = (listener: LiveValueListener) => {
    removeMessageListener(SocketEventTypes.LOCATION_SPEED, listener);
    unsubscribe(SocketSubTypes.Location, locationID);
    setDatasets([]);
  };

  const getId = useCallback(() => {
    return `loc-${locationID}`;
  }, [locationID]);

  useEffect(() => {
    if (locationID) {
      if (isLoadedRef.current === locationID) return;
      isLoadedRef.current = locationID;
      subscribe(SocketSubTypes.Location, locationID);
      update(currentPeriodRef.current, "useEffect with locationID");
      // return () => {
      //   unsubscribe(SocketSubTypes.Location, locationID);
      // }
    }
  }, [locationID, update]);

  return {
    isLoading,
    datasets,
    statistic,
    update,
    load,
    unload,
    getId,
  }
}